export default "__VITE_ASSET__BVZ7Xjvu__"